import { Box, Link, Typography } from '@mui/material'
import CardTAG from '../../CardTAG'
import { ICheckEmailForm } from './types'
import BackButton from '../../buttons/BackButton'
import FormLayout from '../FormLayout'

const CheckEmailForm: React.FC<ICheckEmailForm> = ({ email, onSubmit }) => {
  return (
    <CardTAG title='Check your email'>
      <FormLayout>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Typography variant='bodyRegular' sx={{ marginBottom: 0 }}>
            We sent a password reset link to
          </Typography>
          <Typography variant='bodyBold' color='tagBoxSuccess.text'>
            {email}
          </Typography>
        </Box>

        <Typography>
          If you didn’t receive the email,{' '}
          {
            <Link underline='none' onClick={onSubmit}>
              click here to resend
            </Link>
          }
        </Typography>
        <BackButton href='login' btnText='Back To Log In' />
      </FormLayout>
    </CardTAG>
  )
}

export default CheckEmailForm
